import { DateRange } from './MedicalRecords.types';

export const DATE_RANGE_OPTIONS: Array<{ value: DateRange; label: string }> = [
  { value: 'EVERYTHING', label: 'Everything' },
  { value: 'LAST_MONTH', label: 'Last Month' },
  { value: 'LAST_6_MONTHS', label: 'Last 6 Months' },
  { value: 'LAST_YEAR', label: 'Last Year' }
];

export const DEFAULT_DATE_RANGE: DateRange = 'EVERYTHING';

// The PDF is generated in the background, so we keep checking until it's ready.
export const EXPORT_POLL_INTERVAL_MS = 3000;
